import { useShopAvailability, ShopAvailabilityNotice } from "../../components/shopAvailability";
import { availableDeliveryMethods } from "../../components/storeDelivery";
import { CartResume } from "../../components/cartResume";
import {cartIntent,serverCart} from "../../hooks/cartPersistence";
import {reconcileCart} from "../../api/shop";
import {useCartAmounts} from "../../hooks/useCartAmounts";
import {useRef, useState} from "react";
import { CashPaymentDescription } from "./paymentDescription";
import React, { /*useState,*/ useEffect } from "react";
import { useNavigate } from "react-router-dom";
//Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updateCart,
  setPayment,
  setAlert,
  setLoading,
  updateChekoutAddress,
  updateChekoutPaymentMethod,
  updateChekoutDeliveryMethod,
  updateShippingAddresses,
  updateHistoryOrder,
} from "./../../reducers/userConfigSlice";

import { GoCreditCard } from "react-icons/go";
import { MdOutlineDeliveryDining } from "react-icons/md";
import { CiShop } from "react-icons/ci";
import "./style.css";
import { Button, generateCode /*, Checkbox*/ /*, StateLabel*/ } from "@delibrandev/utils";
import { FaRegMoneyBill1 } from "react-icons/fa6";
/*import { Select } from "@delibrandev/utils";*/
import { FaMobileAlt } from "react-icons/fa";
import { makeOrder } from "../../api/shop";
import { translateMessage } from "@delibrandev/utils/src/function";
import { PaymentGateway } from "../../hooks/paymentGateway";
import { LoaderComponent } from "../../components/loaderComponent";
import { Cart } from "../cart";
import { addCustomerShippingAddress } from "../../api/profile";
import { AddressFields, newAddress, addressFromForm } from "../../components/addressFields";
import { logoutRevision } from "../../hooks/shopSession";

export const MakeOrder = () => {
  console.log("=====> MakeOrder");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDeliveryAdresses = useSelector((state) => state.aplicationConfig.userConfig.userData.addresses.shippingAddresses);
  const checkoutAddress = useSelector((state) => state.aplicationConfig.userConfig.checkout.address);
  const deliveryMethod = useSelector((state) => state.aplicationConfig.userConfig.checkout.deliveryMethod);
  const paymentMethod = useSelector((state) => state.aplicationConfig.userConfig.checkout.paymentMethod);
  const fullname = useSelector((state) => state.aplicationConfig.userConfig.userData.fullname);
  const paymentRequired = paymentMethod?.name === "Tarjeta de crédito";
  const cartProducts = useSelector((state) => state.aplicationConfig.userConfig.cart?.ShoppingCartProducts);
  const hasProducts = Array.isArray(cartProducts) && cartProducts.some((line) => Number(line.quantity) > 0);

  const availability = useShopAvailability();
  const quote = useCartAmounts();
  const submitting = useRef(false);
  const pendingPaymentOrder = useRef(null);
  const pendingPaymentSelection = useRef(null);
  const paymentSelection = JSON.stringify({method: paymentMethod?.paymentMethodId, shipping: deliveryMethod?.shippingMethodId, address: checkoutAddress?.addressId, lines: (Array.isArray(cartProducts) ? cartProducts : []).map(line => ({productId: line.productId || line.Product?.productId, quantity: Number(line.quantity), variantId: line.variantId, itemIds: line.itemIds, note: line.note}))});
  const handleOrder = async () => {
    if (!availability.canOrder || !await availability.check() || !hasProducts || quote.busy || quote.error || !quote.amounts || submitting.current) return null;
    if (paymentRequired && pendingPaymentOrder.current) {
      if (pendingPaymentSelection.current !== paymentSelection) {
        dispatch(setAlert("Este pedido ya está creado. Completa su pago desde el historial antes de iniciar otro."));
        return null;
      }
      return pendingPaymentOrder.current;
    }
    submitting.current = true;
    const endProcess = (data, paymentStatus) => {
      dispatch(updateHistoryOrder({ ...data, paymentStatus: paymentStatus }));
      dispatch(updateCart({ ShoppingCartProducts: [] }));
      dispatch(setPayment(response.data));
      dispatch(setLoading(false));
      navigate("/checkoutPage");
    };

    dispatch(setLoading(true));
    console.log("=====> handleOrder");
    const selectedAddress = userDeliveryAdresses.find((addr) => addr.addressId === checkoutAddress.addressId);
    const payload = {
      paymentMethodId: paymentMethod.paymentMethodId,
      paymentMethod: paymentMethod.paymentMethodId,
      shippingMethodId: deliveryMethod?.shippingMethodId,
      address: deliveryMethod.nameHomeDelivery ? selectedAddress : null,
    };

    let response;
    try { response = await makeOrder(payload); } catch { response = {error:true, message:"No se pudo crear el pedido"}; }
    submitting.current = false;
    if (response && !response.error) {
      if (!paymentRequired) {
        endProcess(response.data, "pending");
      } else {
        pendingPaymentSelection.current = paymentSelection;
        pendingPaymentOrder.current = {
          data: response.data,
          ...response.data,
          paymentMethodId: payload.paymentMethodId,
          urlCallback: "/checkoutPage",
          name: fullname,
          cancelLoading: () => dispatch(setLoading(false)),
          functionCallback: (data, payment) => endProcess(data, payment),
        };
        dispatch(setLoading(false));
        return pendingPaymentOrder.current;
      }
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      dispatch(setLoading(false));
    }
  };


  if (!hasProducts) {
    return (
      <div className="checkout-block eats-checkout-confirm">
        <ShopAvailabilityNotice />
        <p role="status">{availability.canOrder ? "Tu carrito está vacío. Añade productos para continuar con el pedido." : "Tu carrito está vacío. Puedes consultar la carta."}</p>
        <button type="button" className="customButtonColor1" onClick={() => navigate("/")}>
          Elegir productos
        </button>
      </div>
    );
  }

  return userDeliveryAdresses.length === 0 && deliveryMethod?.homeDeliveryIsActive ? (
    <></>
  ) : (
    <div className="checkout-block eats-checkout-confirm">
      <ShopAvailabilityNotice />
      <div className="eats-mobile-checkout-totals"><CartResume canMakeOrder={false} /></div>
      {paymentRequired ? (
        availability.canOrder ? <PaymentGateway callback={handleOrder} /> : <button type="button" className="customButtonColor2" disabled>Pedidos cerrados</button>
      ) : (
        <>
          <div className="mobileRender">
            <div className="flex-gap">
              <div className="" style={{ flex: "1" }}>
                <Button text={"Volver"} icon={null} customClass={"customButtonColor1 w100"} action={() => navigate("/carrito")} />
              </div>
              <div style={{ flex: "0 0 70%" }}>
                <Button
                  text={"Confirmar pedido"}
                  icon={null}
                  customClass={`customButtonColor2 w100 bigMobileButton`}
                  action={handleOrder}
                  disabled={!availability.canOrder || quote.busy || quote.error || !quote.amounts}
                />
              </div>
            </div>
          </div>
          <div className="desktopRender w-100">
            <div style={{ flex: "0 0 100%" }}>
              <Button
                text={"Confirmar pedido"}
                icon={null}
                customClass={`customButtonColor2 w100 bigMobileButton`}
                action={handleOrder}
                  disabled={!availability.canOrder || quote.busy || quote.error || !quote.amounts}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

const Card = ({ data, callback, option }) => {
  let cardUserSelected = "";
  if (option === data.id) cardUserSelected = "cardUserSelected";
  return (
    <div
      className={"cardUser " + cardUserSelected}
      role="button"
      tabIndex={0}
      onClick={callback}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          callback();
        }
      }}
      aria-pressed={option === data.id}
    >
      <div className="userIcon">{data.icon}</div>
      <div className="username">{data.name}</div>
    </div>
  );
};

export const NewDelivery = () => {
  const dispatch = useDispatch();
  const [draft, setDraft] = useState(() => ({ ...newAddress(), addressId: generateCode(), number: "", floor: "", door: "", block: "" }));
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const pending = useRef(false), alive = useRef(true);
  useEffect(() => { alive.current = true; return () => { alive.current = false; }; }, []);
  const createDelivery = async event => {
    event.preventDefault();
    if (pending.current) return;
    const address = addressFromForm(event.currentTarget, draft);
    const revision = logoutRevision();
    const valid = () => alive.current && revision === logoutRevision();
    pending.current = true; setDraft(address); setBusy(true); setError("");
    try {
      const response = await addCustomerShippingAddress({ address });
      if (!valid()) return;
      if (response?.error || !Array.isArray(response?.data?.addresses?.shippingAddresses)) throw new Error("address save failed");
      dispatch(updateShippingAddresses(response.data.addresses.shippingAddresses));
    } catch {
      if (valid()) setError("No hemos podido guardar la dirección. Revisa los datos e inténtalo de nuevo.");
    } finally {
      pending.current = false;
      if (valid()) setBusy(false);
    }
  };

  return <form className="option shop-address-create" aria-label="Añadir dirección de entrega" aria-busy={busy} autoComplete="on" onSubmit={createDelivery}>
    <AddressFields value={draft} onChange={setDraft} disabled={busy} />
    {error && <p role="alert">{error}</p>}
    <button type="submit" className="customButtonColor2 w-100" disabled={busy}>{busy ? "Guardando…" : "Guardar dirección"}</button>
  </form>;
};

export const DeliveryDirection = () => {
  const dispatch = useDispatch();
  const checkoutAddress = useSelector((state) => state.aplicationConfig.userConfig.checkout.address);
  const deliveryMethod = useSelector((state) => state.aplicationConfig.userConfig.checkout.deliveryMethod);
  const userDeliveryAdresses = useSelector((state) => state.aplicationConfig.userConfig.userData.addresses.shippingAddresses);

  useEffect(() => {
    userDeliveryAdresses && userDeliveryAdresses.length > 0 && updateAddress(userDeliveryAdresses[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    userDeliveryAdresses && userDeliveryAdresses.length === 1 && updateAddress(userDeliveryAdresses[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userDeliveryAdresses]);

  const updateAddress = (address) => {
    dispatch(updateChekoutAddress(address));
  };

  if (deliveryMethod?.nameHomeDelivery) {
    return userDeliveryAdresses && userDeliveryAdresses.length === 0 ? (
      <>
        <div className="inputLabel pb-1">No hay ninguna dirección registrada, crea una.</div>
        <NewDelivery />
      </>
    ) : (
      userDeliveryAdresses &&
        userDeliveryAdresses.length &&
        userDeliveryAdresses.map((address) => (
          <label key={address.addressId} className="flex-start" style={{ alignItems: "center", gap: "10px", minHeight: "44px" }}>
            <input
              name="userDeliveryAdress"
              type="radio"
              onChange={() => updateAddress(address)}
              checked={address.addressId === checkoutAddress?.addressId}
            />{" "}
            <span>
              {address.name} ({`${address.street}${address.state && address.state !== "" && " ," + address.state} `})
            </span>
          </label>
        ))
    );
  } else {
    return (
      <>
        <div className="inputLabel">Recogida en tienda</div>
        <div className="pt-1">Se recogerá el pedido en tienda</div>
      </>
    );
  }
};

export const DeliveryMethods = () => {
  const dispatch = useDispatch();
  const deliveryMethods = useSelector((state) => state.aplicationConfig.corporationData?.info?.corporation?.ShippingMethods);
  const deliveryMethod = useSelector((state) => state.aplicationConfig.userConfig.checkout.deliveryMethod);

  const handleDeliveryMethod = (method) => {
    dispatch(updateChekoutDeliveryMethod(method));
  };

  useEffect(() => {
    const available = availableDeliveryMethods(deliveryMethods);
    if (available.length && !available.some(method => method.shippingMethodId === deliveryMethod?.shippingMethodId)) handleDeliveryMethod(available[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="checkout-block">
      <h4 className="flex-start" style={{ gap: "5px", alignItems: "center", fontWeight: "800" }}>
        Entrega
      </h4>
      <hr style={{ margin: "0.1rem 0" }} />
      <div className="cartPayments-list">
        {deliveryMethods &&
          availableDeliveryMethods(deliveryMethods).map((method, index) => (
            <Card
              key={index}
              data={{
                icon: method.nameHomeDelivery ? <MdOutlineDeliveryDining /> : <CiShop />,
                name: method.nameHomeDelivery ? "Domicilio" : "Tienda",
                id: method.shippingMethodId,
              }}
              callback={() => handleDeliveryMethod(method)}
              option={deliveryMethod?.shippingMethodId}
            />
          ))}
      </div>
      <DeliveryDirection selectedDeliveryMethodIndex={deliveryMethod?.shippingMethodId} />
    </div>
  );
};

const PaymentMethods = () => {
  const dispatch = useDispatch();
  const paymentsMethods = useSelector((state) => state.aplicationConfig.corporationData?.info?.corporation?.PaymentMethods);
  const paymentMethod = useSelector((state) => state.aplicationConfig.userConfig.checkout.paymentMethod);
  const deliveryMethod = useSelector((state) => state.aplicationConfig.userConfig.checkout.deliveryMethod);

  const handlePaymentMethod = (method) => {
    dispatch(updateChekoutPaymentMethod(method));
  };

  useEffect(() => {
    paymentsMethods && paymentsMethods.length > 0 && handlePaymentMethod(paymentsMethods[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="checkout-block">
      <h4 className="flex-start" style={{ gap: "5px", alignItems: "center", fontWeight: "800" }}>
        Pago
      </h4>
      <hr style={{ margin: "0.1rem 0" }} />
      <div className="cartPayments-list">
        {paymentsMethods &&
          paymentsMethods.map((method, index) => (
            <Card
              key={index}
              data={{
                icon:
                  method.name === "Tarjeta" || method.name === "Tarjeta de crédito" ? (
                    <GoCreditCard />
                  ) : method.name === "Efectivo" ? (
                    <FaRegMoneyBill1 />
                  ) : (
                    <FaMobileAlt />
                  ),
                name: method.name,
                id: method.paymentMethodId,
              }}
              callback={() => handlePaymentMethod(method)}
              option={paymentMethod?.paymentMethodId}
            />
          ))}
      </div>
      {paymentMethod && paymentMethod.name !== "Tarjeta de crédito" ? (
        <CashPaymentDescription deliveryMethod={deliveryMethod} />
      ) : (
        <></>
      )}
    </div>
  );
};

export const Checkout = () => {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.aplicationConfig.userConfig.cart);
  //const [preview, setPreview] = useState({});

  const cartSync = async () => {
    dispatch(setLoading(true));
    try {
      const response=await reconcileCart(cartIntent(cart,true));
      if(!response || response.error) throw new Error(response?.message || "No se pudo guardar el carrito");
      dispatch(updateCart(serverCart(response.data)));
    } catch(error) {
      dispatch(setAlert({called:true,type:"error",title:"Carrito pendiente de guardar",message:error.message}));
    } finally {dispatch(setLoading(false));}
  };

  useEffect(() => {
    cartSync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="mainContainer eats-checkout-page">
        <LoaderComponent />
        <div className="checkout-container">
          <DeliveryMethods />
          <PaymentMethods />
          <MakeOrder />
        </div>
      </div>
      <div className="myOrder">
        <Cart canMakeOrder={false} />
      </div>
    </>
  );
};
